namespace $ {
	export class $visavis_eigen extends $visavis_plot_plotly {
	}
	
}

